import { QueryClient } from '@tanstack/react-query';
import { useAuthStore } from 'state/store/auth/useAuthStore';

type NavigateFn = (to: string, options?: { replace?: boolean }) => void;

/**
 * Clears auth, routes to login, then wipes the React Query cache after React
 * has applied logout (so authenticated observers are already disabled/unmounted).
 * Clearing synchronously while observers still have enabled:true refetches
 * /iam/me and flashes LoadingOverlay.
 */
export function completeLogout(queryClient: QueryClient, navigate: NavigateFn) {
  useAuthStore.getState().logout();
  navigate('/login', { replace: true });
  queueMicrotask(() => queryClient.clear());
}
